import { topBarInfo } from "@/mocks/homeContent";

export default function TopBar() {
  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-2 px-4 py-2.5 text-xs sm:flex-row sm:gap-3 md:px-6">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-0.5 font-medium text-background-50">
          <i className="ri-flashlight-fill text-[11px]"></i>
          {topBarInfo.badge}
        </span>
        <span className="text-center leading-relaxed text-background-200/90">{topBarInfo.text}</span>
        <a
          href={topBarInfo.linkHref}
          className="hidden items-center gap-1 whitespace-nowrap text-accent-300 transition-colors hover:text-accent-200 md:inline-flex"
        >
          {topBarInfo.linkLabel}
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </div>
  );
}